import { Box, Grid, Typography, Button, TextField, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { ProgressDialog } from "../plungerPage/progressPopup";
import {
  C5_REGISTERS,
  getSetpoints,
  requestSetpoints,
} from "../../utils/controlConfig";
import axios from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import { getUIDescription } from "../SiteAdmin/customerGroupDetails/AssigningCustomerGroupDevice";

export const FlowRateIncCard = ({ unitId, data, fetchData }) => {
  const [flowRateInc, setFlowRateInc] = useState({
    "Automatic SP": "",
    "Discharge PSI (Actual)": "",
    "Discharge PSI (@Time of Sample)": "",
    "Sample Time SP": "",
    "Sample Deadband": "",
    "Setpoint Increment Value": "",
    "Setpoint Decrement Value": "",
    "Minimum Allowed Flow Rate": "",
    "Maximum Allowed Flow Rate": "",
  });
  const [progressOpen, setProgressOpen] = useState(false);
  const [progressSuccess, setProgressSuccess] = useState(false);
  const [progressError, setProgressError] = useState("");

  const fetchFlowRateInc = async () => {
    if (!unitId) return;
    try {
      if (data) {
        setFlowRateInc((prev) => ({
          ...prev,
          "Automatic SP": parseFloat(data._41579 / 10) ?? "",
          "Discharge PSI (Actual)": parseFloat(data._40505 / 10) ?? "",
          "Discharge PSI (@Time of Sample)": parseFloat(data._40624 / 10) ?? "",
          "Sample Time SP": data._41517 ?? "",
          "Sample Deadband": parseFloat(data._41652 / 10) ?? "",
          "Setpoint Increment Value": parseFloat(data._41653 / 10) ?? "",
          "Setpoint Decrement Value": parseFloat(data._41654 / 10) ?? "",
          "Minimum Allowed Flow Rate": parseFloat(data._41717 / 10) ?? "",
          "Maximum Allowed Flow Rate": parseFloat(data._41716 / 10) ?? "",
        }));
      }
    } catch (err) {
      console.error("Failed to get setpoints:", err);
    }
  };

  useEffect(() => {
    if (unitId) {
      fetchFlowRateInc();
    }
  }, []);

  const validateFields = () => {
    const emptyFields = Object.entries(flowRateInc).filter(
      ([key, value]) => value === "" || value === null || value === undefined,
    );
    return emptyFields.map(([key]) => key);
  };

  const updateFlowRate = async () => {
    const missingFields = validateFields();
    if (missingFields.length > 0) {
      toast.error(
        `Please fill in the following fields: ${missingFields.join(", ")}`,
        {
          autoClose: 5000,
        },
      );
      return;
    }
    try {
      const confirmed = window.confirm(
        "Are you sure you want to change the setpoints? Reminder: ALWAYS get Setpoints prior to doing the update. Please ignore if you already did",
      );
      if (!confirmed) return;
      const initialResp = await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
        C5_REGISTERS,
      );
      const baseline = {
        time: Number(initialResp.data.data?.time || 0),
        response: initialResp.data.data?.response || {},
      };
      console.log("Initial baseline time", baseline);
      const sp = (label) => parseFloat(flowRateInc[label]) || 0;
      let cmd = "S";
      cmd += `,${1578},${sp("Automatic SP") * 10}`;
      cmd += `,${504},${sp("Discharge PSI (Actual)") * 10}`;
      cmd += `,${623},${sp("Discharge PSI (@Time of Sample)") * 10}`;
      cmd += `,${1516},${sp("Sample Time SP")}`;
      cmd += `,${1651},${sp("Sample Deadband") * 10}`;
      cmd += `,${1652},${sp("Setpoint Increment Value") * 10}`;
      cmd += `,${1653},${sp("Setpoint Decrement Value") * 10}`;
      cmd += `,${1715},${sp("Maximum Allowed Flow Rate") * 10}`;
      cmd += `,${1716},${sp("Minimum Allowed Flow Rate") * 10}`;
      setProgressOpen(true);
      setProgressSuccess(false);
    
      await axios.post(
        `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/cmd`,
        {
          unitId,
          cmd,
          UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${cmd}`,
        },
        {
          headers: {
            id: "anything",
            "Content-Type": "application/json",
          },
        },
      );
      console.log("Sending command:", cmd);
      setTimeout(() => {
        requestSetpoints(
          unitId,
          "P,1578,1,504,1,623,1,1516,1,1651,1,1652,1,1653,1,1715,1,1716,1",
          baseline,
          setProgressSuccess,
          setProgressError,
          setProgressOpen,
        );
      }, 100);
    } catch (error) {
      console.log("Error to update setpoints", error);
    }
  };

  return (
    <Grid>
      <Paper sx={{ p: 2, bgcolor: "#1e293b", borderRadius: 2 }}>
        <Typography sx={{ mb: 2, fontSize: 14 }}>
          Flow Rate Incremental SPs (Discharge Auto-Learn)
        </Typography>

        <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontSize: { xs: "10px", sm: "11px", md: "12px" } }}
            fullWidth
            onClick={() =>
              getSetpoints(
                unitId,
                "P,1578,1,504,1,623,1,1516,1,1651,1,1652,1,1653,1,1715,1,1716,1",
                setProgressSuccess,
                setProgressError,
                setProgressOpen,
              )
            }
          >
            Get Setpoints
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ fontSize: { xs: "10px", sm: "11px", md: "12px" } }}
            fullWidth
            onClick={updateFlowRate}
          >
            Update
          </Button>
        </Box>

        {Object.entries(flowRateInc).map(([label, value]) => (
          <Box key={label} sx={{ paddingBlock: 0.75 }}>
            <Typography sx={{ fontSize: 13 }}>{label}</Typography>
            <TextField
              variant="outlined"
              disabled={
                true &&
                (label === "Discharge PSI (Actual)" ||
                  label === "Discharge PSI (@Time of Sample)")
              }
              fullWidth
              size="small"
              value={value}
              onChange={(e) =>
                setFlowRateInc((prev) => ({
                  ...prev,
                  [label]: e.target.value,
                }))
              }
              InputProps={{
                sx: {
                  color: "#fff",
                  backgroundColor: "#1f2937",
                  padding: 0.2,
                  fontSize: 13,
                },
              }}
            />
          </Box>
        ))}
      </Paper>
      <ProgressDialog
        open={progressOpen}
        isSuccess={progressSuccess}
        errorMessage={progressError}
        onClose={() => {
          setProgressOpen(false);
          setProgressError("");
        }}
        onRefresh={async () => {
          setProgressOpen(false);
          setProgressError("");
          await fetchData();
        }}
        loadingMessage="Check Device Response. Operation in-progress ..."
        successMessage="Successfully updated!"
      />
    </Grid>
  );
};
